<template>
  <CarContainer title="IN SHOP" :cars="this.cars" />
</template>

<script>
import {
  getFirestore,
  getDocs,
  query,
  collection,
  where
} from "firebase/firestore/lite";

import CarContainer from "./CarContainer.vue"

export default {
  components: { CarContainer },

  data() {
    return {
      cars: null
    };
  },

  mounted() {
    this.getCars();
  },

  methods: {
    async getCars() {
      const q = query(
        collection(getFirestore(), "cars"),
        where("availability", "==", "available")
      );
      this.cars = (await getDocs(q)).docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    }
  },
};
</script>
